module.exports = __webpack_public_path__ + "img/orange_079.647c97c2.png";